import { Box, Button } from "@chakra-ui/react";
import Form from "@rjsf/chakra-ui";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";

import { LOGIN_FORM_WIDTH } from "@/pages/login-page";

import { getCorrectLoginLink } from "../utils/get-correct-login-link";

export const isTestEnvironment = () => window.location.hostname.includes("localhost");

export const schema: RJSFSchema = {
  title: "Log in link converten",
  type: "object",
  required: ["loginLink"],
  properties: {
    loginLink: {
      type: "string",
      title: "Inlog link",
    },
  },
};

export const uiSchema: UiSchema = {
  loginLink: {
    "ui:placeholder": "Voer inlog link in",
  },
};

export function LoginLinkConverter() {
  if (!isTestEnvironment()) return null;

  return (
    <Box w={LOGIN_FORM_WIDTH} sx={{ ".convert-login-link-form": { pt: 2, w: LOGIN_FORM_WIDTH } }}>
      Na het krijgen van email hier je inlog link plakken om naar de correcte link te gaan:
      <Form
        className="convert-login-link-form"
        schema={schema}
        onSubmit={({ formData }) => {
          const { loginLink } = formData;
          const correcteLink = getCorrectLoginLink(loginLink);
          console.log(correcteLink);

          window.location.href = correcteLink;
        }}
        uiSchema={{
          ...uiSchema,
          "ui:title": "", // This hides the schema title
        }}
        validator={validator}
      >
        <Button ml="auto" type="submit" variant="primary">
          Convert en ga naar correcte link
        </Button>
      </Form>
    </Box>
  );
}
